import api from "./Api";

class VendedorEnderecoService {
  GetVendedorEndereco(payload) {
    return api.get("/v1/vendedorEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  PostVendedorEndereco(payload) {
    return api.post("/v1/vendedorEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  PutVendedorEndereco(payload) {
    return api.put("/v1/vendedorEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteVendedorEndereco(payload) {
    return api.delete("/v1/vendedorEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  GetVendedorEnderecoOData(payload) {
    return api.get("/OData/VendedorEndereco" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new VendedorEnderecoService();
